<template>
    <div>
        <h5 :class="['row-col-text-field__label', labelClass]">
            {{ label }}
            <v-chip v-if="required" class="ma-2" x-small outlined color="primary">{{$t("form.mandatory")}}</v-chip>
        </h5>
        <v-row>
            <v-col>
                <v-text-field
                    :value="value"
                    @input="updateValue"
                    :rules="allRules"
                    outlined
                    :hint="hint"
                    :persistent-hint="persistentHint"
                    v-if="!readonly"
                >
                    <template v-slot:append-outer>
                        <slot name="append-outer" />
                    </template>
                </v-text-field>
                <v-text-field
                    v-else
                    :value="value"
                    readonly
                    disabled
                ></v-text-field>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        rules: {
            type: Array,
            required: true
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false
        },
        hint: {
            type: String,
            default: ""
        },
        persistentHint: {
            type: Boolean,
            default: false
        },
        labelClass: {
            type: [String, Array, Object],
            default: ""
        }
    },
    methods: {
        updateValue(value) {
            this.$emit('input', value);
        }
    },
    computed: {
        allRules() {
            let rules = this.rules || [];
            if (this.required) {
            rules = [...rules, v => !!v || this.$t('forms.field.validation.required')];
            }
            return rules;
        }
    }
}
</script>
